import type { TrackingService } from './TrackingService'
import type { Member } from '@/features/iam/members/Member'
import type { UserData } from '@/features/iam/users/UserData'

/**
 * Used when PostHog is not configured, such as in local development.
 */
export class NoOpTrackingService implements TrackingService {
  /** @inheritDoc */
  identify(member: Member, _userData: UserData) {
    console.debug('[NoOp] Identifying as', member.displayName)
  }

  /** @inheritDoc */
  reset() {
    console.debug('[NoOp] Resetting session recording')
  }

  static create() {
    return new NoOpTrackingService()
  }
}
